import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { brightStarLogin } from "../API/index";
import { ThemeContext } from "../assets/theme/ThemeContext";
import { completeLogin } from "../utils/auth";
import AuthLayout, { AuthPasswordInput } from "../components/AuthLayout";

const Login = () => {
  const [loginDetails, setLoginDetails] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const focus = useRef();
  const { updateTheme } = useContext(ThemeContext);

  const dispatch = useDispatch();

  useEffect(() => {
    focus.current.focus();
  }, []);

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setLoginDetails({ ...loginDetails, [name]: value });
  };

  const onSignIn = async () => {
    setIsLoading(true);
    if (loginDetails?.email && loginDetails?.password) {
      try {
        const res = await brightStarLogin(loginDetails);
        const redirectPath = await completeLogin(res, { dispatch, updateTheme });

        if (redirectPath) {
          navigate(redirectPath);
        }
      } catch (err) {
        // API errors are surfaced by the shared axios interceptor.
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      toast.warning("Please enter email & password");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSignIn();
  };

  return (
    <AuthLayout>
      <h2 className="auth-title">Log in</h2>
      <p className="auth-subtitle">Welcome back. Enter your details to continue.</p>
      <form noValidate onSubmit={handleSubmit}>
        <label className="visually-hidden" htmlFor="login-email">
          Email address
        </label>
        <input
          ref={focus}
          onChange={(e) => onChange(e)}
          type="email"
          name="email"
          id="login-email"
          className="auth-input"
          placeholder="E-mail address"
          autoComplete="email"
        />
        <AuthPasswordInput
          id="login-password"
          name="password"
          label="Password"
          placeholder="Password"
          autoComplete="current-password"
          onChange={(e) => onChange(e)}
        />
        <div className="auth-actions">
          <button type="submit" className="auth-submit" disabled={isLoading}>
            {isLoading && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Log in
          </button>
          <a
            href="#"
            className="auth-forgot"
            onClick={(e) => {
              e.preventDefault();
              navigate("/forget-password");
            }}
          >
            Forgot password?
          </a>
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login;
